module.exports = __webpack_public_path__ + "assets/img/4.8c96911f.jpg";